import React from "react";

const defaultResettlementData = [
  {
    projectName: "",
    state: "",
    district: "",
    pafCount: "",
    pafCoveredPercent: "",
    amountPaid: "",
  },
];

const RehabilitationResettlementTable = ({
  resettlementData,
  setResettlementData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...resettlementData];
    updated[index][field] = value;
    setResettlementData(updated);
  };

  const addRow = () => {
    setResettlementData([
      ...resettlementData,
      {
        projectName: "",
        state: "",
        district: "",
        pafCount: "",
        pafCoveredPercent: "",
        amountPaid: "",
      },
    ]);
  };

  const removeRow = () => {
    if (resettlementData.length > 1) {
      setResettlementData(resettlementData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>S No.</th>
              <th style={header}>Name of Project for which R&R is ongoing</th>
              <th style={header}>State</th>
              <th style={header}>District</th>
              <th style={header}>No. of Project Affected Families (PAFs)</th>
              <th style={header}>% of PAFs covered by R&R</th>
              <th style={header}>Amounts paid to PAFs in the FY (In INR)</th>
            </tr>
          </thead>
          <tbody>
            {resettlementData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name"
                    value={row.projectName}
                    onChange={(e) =>
                      handleChange(index, "projectName", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="State"
                    value={row.state}
                    onChange={(e) =>
                      handleChange(index, "state", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="District"
                    value={row.district}
                    onChange={(e) =>
                      handleChange(index, "district", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="No."
                    value={row.pafCount}
                    onChange={(e) =>
                      handleChange(index, "pafCount", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="%"
                    value={row.pafCoveredPercent}
                    onChange={(e) =>
                      handleChange(index, "pafCoveredPercent", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Rs."
                    value={row.amountPaid}
                    onChange={(e) =>
                      handleChange(index, "amountPaid", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default RehabilitationResettlementTable;
